/* eslint-disable */
import $ from 'jquery';
import backbone from 'backbone';
import _ from 'underscore';
import UrlInputView from '@bingads-webui-component-legacy/url-input/view/url-input';
import AssociationsEditorBase from '@bingads-webui-campaign-legacy/adextension-associations-editor/view/index';
import dialogDecorator from '@bingads-webui-component-legacy/dialog/dialogDecorator';
import * as _SharedRepository from '@bingads-webui-campaign-legacy/adextension-shared/service/repository';
import EditorView from '@bingads-webui-campaign-legacy/adextension-review/view/extensionEditor';
import previewTemplate from '@bingads-webui-campaign-legacy/adextension-review/template/extensionPreview.pug';
import rowTemplate from '@bingads-webui-campaign-legacy/adextension-review/template/gridRowTemplate.pug';
import * as _panelDecorator from '@bingads-webui-campaign-react/panel-decorator';
var schema = window.globalLegacySchema.get('ReviewAdExtension');
var $i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/adextensions');
var SharedRepository = _SharedRepository.default;
var panelDecorator = _panelDecorator.panelDecorator;
var i18nKeys = {
  title: 'AdExtensions_Review_Editor_Title',
  subtitle: ['NewCampaign_AddReviewAdExtension_Subtitle'],
  library_title: 'AdExtensions_Review_Editor_Available',
  selected_title: 'AdExtensions_Review_Editor_Selected',
  create_link: 'AdExtensions_Review_Editor_CreateNew',
  create_title: 'AdExtensions_Review_Dialog_Title_Add',
  delete_btn: 'AdExtensions_Review_Editor_Delete',
  delete_confirm: 'AdExtensions_Review_Delete_Warning',
  edit_btn: 'AdExtensions_Review_Editor_Edit',
  edit_title: 'AdExtensions_Review_Dialog_Title_Edit',
  inlineAlert: 'AdExtensions_Review_Max_Select_Notification'
};
var dialogOptions = {
  position: 'center',
  maxWidth: 1000
};
var view = AssociationsEditorBase.extend({
  initialize: function (options) {
    var Editor = options && options.usePanel ? panelDecorator(EditorView, {
      i18n: $i18n,
      panelReadyAriaLabel: $i18n.getString('Association editor side panel opened'),
      panelClassName: options.panelClassName
    }) : dialogDecorator.decorate(EditorView, dialogOptions);
    _.extend(options || ({}), {
      idField: schema.key,
      data: new SharedRepository({
        schema: schema,
        afterChangeComitted: function () {
          if (_.isFunction(options.updateContext)) {
            options.updateContext(['AccountAdExtensionsGrid', 'CampaignAdExtensionsGrid', 'AdGroupAdExtensionsGrid']);
          }
        }
      }),
      template: {
        preview: previewTemplate,
        rowTemplate: rowTemplate
      },
      extensionType: 'ReviewExtension',
      maxSelectedItemsCount: 20,
      CreateForm: Editor,
      EditForm: Editor,
      i18nKeys: _.extend({}, i18nKeys, options.i18nKeys || ({}))
    });
    AssociationsEditorBase.prototype.initialize.call(this, options);
  }
});
export default view;

